/**
 * Browser stub for image-processing-sharp.
 *
 * This module is used in browser builds (via conditional package imports)
 * instead of the real image-processing-sharp module, which depends on
 * the Node.js-only "sharp" package.
 *
 * All functions throw at runtime. They are only referenced during graph
 * compilation (registerProcessFunction) but never actually called in
 * browser environments.
 */

export type ColourspaceEnum = any
export type Metadata = any

export interface SharpConfig {
    concurrency?: number
    cache?:
        | {
              memory?: number
              files?: number
              items?: number
          }
        | false
    simd?: boolean
}

export const SharpPresets = {
    largeImages: (_maxConcurrency = 2): SharpConfig => ({concurrency: _maxConcurrency, cache: false, simd: true}),
    smallImages: (): SharpConfig => ({concurrency: 0, cache: {memory: 200, files: 50, items: 500}, simd: true}),
    lowMemory: (): SharpConfig => ({concurrency: 1, cache: false, simd: true}),
} as const

function notAvailable(name: string): never {
    throw new Error(`ImageProcessingSharp.${name} is not available in browser environments`)
}

export function configureSharp(..._args: any[]): any {
    notAvailable("configureSharp")
}

export function getSharpStatus(..._args: any[]): any {
    notAvailable("getSharpStatus")
}

export namespace ImageProcessingSharp {
    export function toSharpImageData(..._args: any[]): any {
        notAvailable("toSharpImageData")
    }
    export async function fromSharpImageData(..._args: any[]): Promise<any> {
        notAvailable("fromSharpImageData")
    }
    export async function resize(..._args: any[]): Promise<any> {
        notAvailable("resize")
    }
    export async function extendCanvas(..._args: any[]): Promise<any> {
        notAvailable("extendCanvas")
    }
    export function create(..._args: any[]): any {
        notAvailable("create")
    }
    export async function convolve(..._args: any[]): Promise<any> {
        notAvailable("convolve")
    }
    export function encodeTIFF(..._args: any[]): any {
        notAvailable("encodeTIFF")
    }
    export function encodePNG(..._args: any[]): any {
        notAvailable("encodePNG")
    }
    export function encodeJPEG(..._args: any[]): any {
        notAvailable("encodeJPEG")
    }
    export function encodeWebP(..._args: any[]): any {
        notAvailable("encodeWebP")
    }
    export async function decodeImage(..._args: any[]): Promise<any> {
        notAvailable("decodeImage")
    }
    export async function getImageMetadata(..._args: any[]): Promise<any> {
        notAvailable("getImageMetadata")
    }
}
